import DisponibilitesCalendar from "@/components/formateur/DisponibilitesCalendar";

export default function DisponibilitesEditPage() {
    return (
        <div className="mx-auto max-w-6xl px-6 py-10" data-testid="page-disponibilites-edit">
            <div className="mb-8">
                <div className="text-xs uppercase tracking-[0.25em] text-brand-orange">Mes disponibilités</div>
                <h1 className="mt-3 font-display text-4xl font-normal tracking-tightest">
                    Calendrier d'intervention
                </h1>
                <p className="mt-2 max-w-2xl text-brand-smoke">
                    Indiquez vos disponibilités jusqu'au 31 décembre 2027.
                </p>
            </div>
            <DisponibilitesCalendar mode="edit" />
        </div>
    );
}
